import React from 'react'
import classNames from 'classnames'

import DisplayIcon from '@toasttab/shared/src/components/atoms/DisplayIcon/DisplayIcon'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'

const ProductHighlights = ({ body }: { body: any }) => {
  return (
    <section className='mb-10 lg:mb-16'>
      <div className='ds-wrapper'>
        <div className='ds-container lg:ds-grid'>
          <div className='col-span-4 lg:col-span-12'>
            <div className='flex flex-col items-center lg:items-stretch lg:flex-row'>
              {body.highlights.map((highlight: any, i: number) => {
                const highlightClass = classNames(
                  'text-center group/highlight relative bg-white lg:rounded-base lg:px-6 !max-w-[279px] !max-h-[128px]',
                  {
                    'lg:!mb-0': i + 1 === body.highlights.length
                  }
                )
                const keyId = `${highlight.heading}-${i}`
                return (
                  <div
                    className='mb-4 lg:mb-0 !max-w-[264px] !border-box'
                    key={`ph-${keyId}`}
                  >
                    <div className={highlightClass}>
                      <DisplayIcon
                        classes='mb-2 mx-auto w-10 h-10'
                        iconName={highlight.icon}
                      />
                      <Typography
                        allowHtml={false}
                        as='h5'
                        classes='!text-gray-125'
                        variation='h5'
                      >
                        {highlight.heading}
                      </Typography>
                      <Typography
                        allowHtml={false}
                        as='p'
                        classes='text-secondary'
                        variation='default'
                      >
                        {highlight.description}
                      </Typography>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductHighlights
